import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { URL } from '../../util/ambienteActions';
import { VERIFICAR_VINCULO_ITINERARIO_e_MOTORISTA } from '../types';

export default function verificaVinculoItinerarioEMotorista(idItinerario, idEmpresa) {    
    const url = `${URL}/itinerario/${idItinerario}/empresa/${idEmpresa}/verifica-vinculo-itinerario-e-motorista`
        
    return dispatch => axios.get(url, null, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
        type: VERIFICAR_VINCULO_ITINERARIO_e_MOTORISTA,
        payload: response
        })
    );
}